import { z } from "zod"

import {
  visitCompletionSubmitV1Schema,
} from "./visit-completion-v1.js"
import { entityIdSchema } from "./identifiers.js"

export const visitCompletionSubmitV2Schema = z.object({
  ...visitCompletionSubmitV1Schema.shape,
  evidenceMediaIds: z.array(entityIdSchema).max(25),
}).strict().superRefine((value, context) => {
  const completed = value.outcome === "Completed"
  if (
    completed !== (value.exceptionId === null) ||
    completed !== (value.remainingScope === null) ||
    completed !== (value.reason === null)
  ) {
    context.addIssue({
      code: "custom",
      message: "Only incomplete outcomes carry exception details.",
      path: ["outcome"],
    })
  }
  if (value.outcome === "No Access" && value.attemptedContact === null) {
    context.addIssue({
      code: "custom",
      message: "No Access requires attempted-contact details.",
      path: ["attemptedContact"],
    })
  }
  if (
    value.customerAcknowledgment.signatureMediaId !== null &&
    !value.evidenceMediaIds.includes(
      value.customerAcknowledgment.signatureMediaId,
    )
  ) {
    context.addIssue({
      code: "custom",
      message: "Signature evidence must be completion evidence.",
      path: ["customerAcknowledgment", "signatureMediaId"],
    })
  }
})

export type VisitCompletionSubmitV2 = z.infer<
  typeof visitCompletionSubmitV2Schema
>
